<template>

  <nav-bar :returnAction="true" :pageName="'Relatos'" @return="$router.push(`/patients`)"/>
  
  <main-container :onlyNav="true">
    <div class="d-flex justify-content-center">
      <h5 class="fw-bold">{{patientStore.patient.name}}</h5>
    </div>
    <list-group v-if="reportStore.reports.length > 0">
      <list-item class="list-group-item list-group-item-action px-2" v-for="obj in reportStore.reports" :key="obj.id" v-on:click="$router.push(`/patients/${patientId}/reports/${obj.id}`)">   
        <template v-slot:title>           
          <h5 class="mb-1 fw-bold">{{ obj.title }}</h5>                                             
        </template>
        <template v-slot:info>
          <HumorEmojis class="" :humor="obj.humor" />            
        </template>      
        <template v-slot:complement>
          <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex w-100">
              <p class="mb-1">{{ formatShortDate(obj.date) }}</p> 
              <p class="mb-1 px-1">{{ `(${convertPeriod(obj.period)})` }}</p> 
            </div>
            <div class="d-flex align-items-center px-2">
              <font-awesome-icon icon="check-double" class="blue" v-if="obj.viewingDate" />              
            </div>
          </div>                              
        </template>
      </list-item>
    </list-group>
    <list-group class="list-group" v-else>
      <list-item class="list-group-item list-group-item-action">   
        <template v-slot:title>            
          <h5 class="mb-1 fw-bold">Nenhum Relato Encontrado!</h5>                        
        </template>            
      </list-item>         
    </list-group>
  </main-container>         
</template>

<script>
import HumorEmojis from "../../components/Humor/HumorEmojis.vue"
import { useReportStore } from "../../store/report";
import { usePatientStore } from "../../store/patient";
import { formatShortDate, convertPeriod } from "../../services/formatters";

export default {  
  name: 'PatientReportsListView',
  inject:["mySpinner"],  
  components: {
    HumorEmojis
  },
  setup() {
    const reportStore  = useReportStore();
    const patientStore = usePatientStore();
    return { reportStore, patientStore }
  },  
  props: {
    patientId:{type:String},    
  },  
  async mounted() {    
    this.mySpinner.loading = true;
    await this.reportStore.getReports(this.patientId);
    this.mySpinner.loading = false;
  },
  methods: {
    formatShortDate,
    convertPeriod
  }
}
</script>

<style lang="css" scoped>
  @import'../../assets/css/_colors';
  @import'../../assets/css/_patients';
</style>
